import * as moment from 'moment';

export function formatSetupWaiting(waitingSince: string, now: moment.Moment = moment()): string {
  const days = now.clone().startOf('day').diff(moment(waitingSince).startOf('day'), 'days');

  if (days <= 0) {
    return 'heute';
  }

  return days === 1 ? '1 Tag' : `${ days } Tage`;
}
